module.exports = __webpack_public_path__ + "static/media/defaultgray.c87a423d.svg";